const B_1 = [
    {
        title: '设置资格审查内容',
        path: '/bidding/projectflow/kaibiao/szzgscnr/list'
    }
]
export default {
    path: 'szzgscnr',
    component: () => import(/*webpackChunkName: 'bidding-kai-szzgscnr'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/kai/zi-ge-shen-cha-settings/list'),
            meta: {
                title: '标段列表',
                bread: B_1
            },
        },
        {
            path:"form",
            component: () => import('@views/bidding/views/project-flow/kai/zi-ge-shen-cha-settings/form'),
            meta: {
                title: '设置资格审查内容',
                bread: B_1
            },
        },
        
    ]
}